<template>
  <div
    :class="['radio-option', { selected: isSelected }]"
    :id="id"
    @click="selectOption"
  >
    <input
      type="radio"
      :name="name"
      :value="value"
      :checked="isSelected"
      @change="emitSelection"
      class="hidden-radio"
      :id="id"
    />
    <label :for="value" class="radio-label">
      <slot></slot>
    </label>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "CustomRadio",
  props: {
    value: String,
    modelValue: String,
    name: String,
    id: String,
  },
  setup(props, { emit }) {
    const isSelected = computed(() => props.value === props.modelValue);

    const selectOption = () => {
      emit("update:modelValue", props.value);
    };

    const emitSelection = (event) => {
      emit("update:modelValue", event.target.value);
    };

    return {
      isSelected,
      selectOption,
      emitSelection,
    };
  },
});
</script>

<style lang="scss" scoped>
.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  margin-bottom: 10px;
  transition: all 0.3s ease;
  border-radius: 0.5625rem;
  border: 1px solid #ddd;
  background: #fff;
}

.radio-option.selected {
  border-radius: 0.5625rem;
  border: 1px solid #2c7040;
  background: #e6f4ea;
}

.hidden-radio {
  display: none;
}
</style>
